<template>
  <div class="d-inline-block">
    <slot name="activator" v-bind:toggle="toggle">
      <v-btn
        @click.stop="open = true"
        :block="block"
        :icon="icon"
        :flat="flat"
        :color="color"
        class="ma-0"
      >
        <v-icon :left="!icon" v-if="prependIcon">mdi-paperclip</v-icon>
        <span v-if="label && !icon">{{ label }}</span>
        <span v-else-if="!icon">{{ title }}</span>
        <v-icon :right="!icon" v-if="appendIcon">mdi-paperclip</v-icon>
      </v-btn>
    </slot>
    <v-dialog v-if="file" v-model="open" lazy>
      <v-layout column>
        <v-flex d-flex xs12>
          <v-toolbar :class="themes.candidate.light.dialogTitle">
            <v-toolbar-title>{{ title }} Preview</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="open = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
        </v-flex>
        <v-card>
          <v-container fluid grid-list-xs>
            <v-layout row wrap fill-height>
              <v-flex d-flex>
                <v-responsive
                  v-if="isImage"
                  :height="`${height}px`"
                  :style="
                    `background: center no-repeat url('${file.url}'); background-size: contain;`
                  "
                />
                <v-responsive v-else>
                  <iframe :src="file.url" :height="height" width="100%" style="border: 0;"></iframe>
                </v-responsive>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-layout>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    appendIcon: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
    icon: { type: Boolean, default: false },
    color: { type: String },
    file: { type: [Object, File] },
    flat: { type: Boolean, default: false },
    label: { type: String, default: '' },
    prependIcon: { type: Boolean, default: false },
    title: { type: String, default: '' },
  },
  data() {
    return {
      open: false,
    }
  },
  computed: {
    isImage() {
      if (typeof this.file === 'object') {
        return /^image\//.test(this.file.content)
      } else {
        return false
      }
    },
    height() {
      return this.$vuetify.breakpoint.height * 0.7
    },
  },
  methods: {
    toggle() {
      this.open = !this.open
    },
  },
}
</script>
